<template>
  <div>
    <VasionSchedulersPage title="Import / Export" />
  </div>
</template>

<script>
import VasionSchedulersPage from '@/components/shared/VasionSchedulersPage.vue';

export default {
  name: 'ImportExport',
  components: {
    VasionSchedulersPage,
  },
  data: function () {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
